import React from "react";
import ReactDOM from "react-dom";
//redux
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import redux from "./redux";
import thunk from "redux-thunk";
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import { getInitialLocale } from "./assets/lang/localeUtils";
import { initTheme } from "./assets/lang/themeUtils";
//redux
import "bootstrap/dist/css/bootstrap.css";
import "./global.css";
import "./theme.css";
import App from "./routes/App";

import {
  setLocale,
  loadTranslations,
  syncTranslationWithStore,
} from "react-redux-i18n";
import { initConextionSocket } from './redux/actions/eventActions';

const translations = {
  en: require("./assets/lang/en.json"),
  es: require("./assets/lang/es.json"),
  he: require("./assets/lang/he.json"),
};
const middleware = applyMiddleware(thunk);
const container = document.getElementById("app");
const store = createStore(redux, middleware);
let persistor = persistStore(store);
syncTranslationWithStore(store);
store.dispatch(loadTranslations(translations));
initTheme();
store.dispatch(setLocale(getInitialLocale()));
store.dispatch(initConextionSocket());

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  container
);
